import { Component } from '@angular/core';


@Component({
  selector: '[header_nav]',
  templateUrl: 'header-nav.component.html',
  styleUrls: ['./header-nav.component.css']
})
export class HeaderNavComponent  {
  skipToMain(){
    let element = document.getElementById('content');
    element.setAttribute('tabindex','-1') // You can set tabindex in HTML too than in JS
    element.focus()
  }

}
